module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-2 columns small-centered"
  }, [_c('a', {
    staticClass: "button primary trans-uppercase",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack($event)
      }
    }
  }, [_vm._v("Vissza")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-2 columns small-centered"
  }, [_c('router-link', {
    staticClass: "button secondary trans-uppercase",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Nyitóoldal")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 columns small-centered text-center"
  }, [_c('h3', [_vm._v("A kért oldal nem található")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2956dded!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageNotFound.vue
// module id = 467
// module chunks = 2